// Juo Subscriptions Widget - Main Script

// Collapsible functionality
function createCollapsible(el, initial) {
  if (initial === void 0) {
    initial = false;
  }

  var isOpen = initial;

  el.style.height = isOpen ? "auto" : "0";
  el.style.overflow = "hidden";

  function open() {
    if (isOpen) {
      return;
    }
    isOpen = true;
    el.style.height = el.scrollHeight + "px";
  }

  function close() {
    if (!isOpen) {
      return;
    }
    isOpen = false;
    el.style.height = el.scrollHeight + "px";
    requestAnimationFrame(function () {
      el.style.height = "0px";
    });
  }

  el.style.transition = "height 300ms ease-in-out";
  el.addEventListener("transitionend", function (e) {
    if (e.target !== el) {
      return;
    }
    if (isOpen) {
      el.style.height = "auto";
    }
  });

  return {
    open: open,
    close: close,
    el: el,
  };
}

// Format Money functionality
function formatMoney(cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || "${{amount}}";

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split(".");
    var dollars = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      "$1" + thousands
    );
    var cents_part = parts[1] ? decimal + parts[1] : "";

    return dollars + cents_part;
  }

  var match = formatString.match(placeholderRegex);
  if (match) {
    switch (match[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
    }
  }

  return formatString.replace(placeholderRegex, value);
}

// Main Widget Logic
(function () {
  function updatePrice(el, value, moneyFormat) {
    if (el == null) {
      return;
    }
    return (el.innerHTML =
      '<span class="money">' + formatMoney(value, moneyFormat) + "</span>");
  }

  function getAllocatedSellingPlanById(variant, id) {
    return variant.sellingPlans.find(function (plan) {
      return plan.id === Number(id);
    });
  }

  function initSellingPlanInput(form) {
    var el = form.querySelector('input[name="selling_plan"]');

    if (!el) {
      el = document.createElement("input");
      el.type = "hidden";
      el.name = "selling_plan";
      form.append(el);
    }

    return el;
  }

  function initWidget(variants, variantId, moneyFormat) {
    var forms = Array.from(
      document.querySelectorAll('form[action$="/cart/add"]')
    );

    var sellingPlanInputs = forms.map(initSellingPlanInput);

    var widget = document.querySelector("#juo-subscription-widget");

    if (!widget) {
      return;
    }

    // Initialize SubscriptionWidgetConfig for price updater compatibility
    if (!window.SubscriptionWidgetConfig) {
      window.SubscriptionWidgetConfig = { formattedPrices: {} };
    }

    // Build formatted prices for all variants and their selling plans
    variants.forEach(function (variant) {
      var formattedUnit =
        '<span class="money">' +
        formatMoney(variant.price, moneyFormat) +
        "</span>";
      var sellingPlansFormatted = {};

      variant.sellingPlans.forEach(function (plan) {
        sellingPlansFormatted[plan.id] = {
          price:
            '<span class="money">' +
            formatMoney(plan.price, moneyFormat) +
            "</span>",
        };
      });

      window.SubscriptionWidgetConfig.formattedPrices[variant.id] = {
        unit: formattedUnit,
        sellingPlans: sellingPlansFormatted,
      };
    });

    var priceElement = widget.querySelector('[part="subscription-price"]');
    var basePriceElement = widget.querySelector('[part="price price--base"]');
    var comparePriceElement = widget.querySelector('[part="compare-price"]');
    var sellingPlanSelectorElement = widget.querySelector('[part="select"]');

    if (!sellingPlanSelectorElement) {
      return;
    }

    function getMode() {
      var checkedInput = widget.querySelector('input[name="mode"]:checked');
      return checkedInput ? checkedInput.value : "otp";
    }

    function getValue() {
      if (getMode() === "otp") {
        return "";
      }

      var checkedPlan = widget.querySelector(
        'input[name="selling_plan"]:checked'
      );
      return checkedPlan ? checkedPlan.value : "";
    }

    function populateSellingPlanId() {
      var value = getValue();

      sellingPlanInputs.forEach(function (sellingPlanInput) {
        sellingPlanInput.value = value;
        // Dispatch change event to notify other scripts (like dynamicPrice updater)
        sellingPlanInput.dispatchEvent(new Event("change", { bubbles: true }));
      });

      // Also dispatch custom event to trigger price update
      document.dispatchEvent(new CustomEvent("natulimOptionValueChanged"));
    }

    function getActiveVariant() {
      var url = new URL(window.location.href);
      var activeVariantId = url.searchParams.get("variant") || variantId;
      return (
        variants.find(function (v) {
          return v.id == activeVariantId;
        }) || variants.find(Boolean)
      );
    }

    function updateSaveBadge(comparePrice, price) {
      var saveElement = widget.querySelector('[data-ref="save"]');

      if (saveElement) {
        var percentage = (price / comparePrice) * 100;
        saveElement.innerHTML = "" + (100 - Math.round(percentage));
      }
    }

    function updateSellingPlans(sellingPlans, activeVariantId) {
      sellingPlans = sellingPlans || [];

      if (
        sellingPlanSelectorElement.dataset.activeVariant ===
        String(activeVariantId)
      ) {
        return;
      }

      var html = "";
      sellingPlans.forEach(function (plan, index) {
        var checked = index === 0 ? "checked" : "";
        html += '<label class="j-plan-button">';
        html +=
          '<input type="radio" name="selling_plan" value="' +
          plan.id +
          '" ' +
          checked +
          ">";
        html += '<span class="j-plan-button-text">' + plan.name + "</span>";
        html += "</label>";
      });
      sellingPlanSelectorElement.innerHTML = html;

      if (sellingPlans.length === 0) {
        return;
      }

      sellingPlanSelectorElement.dataset.activeVariant = activeVariantId;

      // Add event listeners to new radio buttons
      var planRadios = sellingPlanSelectorElement.querySelectorAll(
        'input[name="selling_plan"]'
      );
      planRadios.forEach(function (radio) {
        radio.addEventListener("change", update);
      });

      populateSellingPlanId();
    }

    function updateView() {
      var activeVariant = getActiveVariant();
      var mode = getMode();

      // Always update selling plans list
      updateSellingPlans(activeVariant.sellingPlans, activeVariant.id);

      // Get the first available selling plan for subscription price display
      var allocatedPlan = getAllocatedSellingPlanById(
        activeVariant,
        getValue()
      );

      // If no allocated plan found, try to get the first available one
      if (
        !allocatedPlan &&
        activeVariant.sellingPlans &&
        activeVariant.sellingPlans.length > 0
      ) {
        allocatedPlan = activeVariant.sellingPlans[0];
      }

      // Always update OTP price (regardless of selected mode)
      updatePrice(basePriceElement, activeVariant.price, moneyFormat);

      // Update OTP compare price
      var otpComparePriceElement = widget.querySelector(
        '.j-otp [part="compare-price"]'
      );
      if (
        activeVariant.comparePrice &&
        activeVariant.comparePrice > activeVariant.price
      ) {
        updatePrice(
          otpComparePriceElement,
          activeVariant.comparePrice,
          moneyFormat
        );
      } else if (otpComparePriceElement) {
        otpComparePriceElement.innerHTML = "";
      }

      // Always update subscription price (regardless of selected mode)
      if (allocatedPlan) {
        widget.classList.remove("juo-hidden");

        // Update subscription price
        updatePrice(priceElement, allocatedPlan.price, moneyFormat);

        // Update save badge
        if (allocatedPlan.comparePrice > allocatedPlan.price) {
          updateSaveBadge(allocatedPlan.comparePrice, allocatedPlan.price);
        }

        // Update subscription compare price
        if (
          allocatedPlan.price < allocatedPlan.comparePrice &&
          activeVariant.price !== allocatedPlan.price
        ) {
          updatePrice(
            comparePriceElement,
            allocatedPlan.comparePrice,
            moneyFormat
          );
        } else if (comparePriceElement) {
          comparePriceElement.innerHTML = "";
        }
      } else {
        // No selling plans available - hide widget only if in subscription mode
        if (mode === "subscription") {
          widget.classList.add("juo-hidden");
        } else {
          widget.classList.remove("juo-hidden");
        }
      }
    }

    var collapsibleEl = widget.querySelector(".collapsible");
    var collapsible =
      collapsibleEl == null
        ? null
        : createCollapsible(collapsibleEl, getMode() === "subscription");

    var _isUpdating = false;

    function update() {
      if (_isUpdating) return;
      _isUpdating = true;
      try {
        populateSellingPlanId();
        updateView();

        if (collapsible) {
          if (getMode() === "subscription") {
            collapsible.open();
          } else {
            collapsible.close();
          }
        }
      } finally {
        _isUpdating = false;
      }
    }

    update();
    document.addEventListener("change", update);

    // When user clicks a plan button, automatically select subscription mode
    sellingPlanSelectorElement.addEventListener("click", function (e) {
      if (
        e.target.name === "selling_plan" ||
        e.target.closest(".j-plan-button")
      ) {
        var subscriptionRadio = widget.querySelector(
          'input[name="mode"][value="subscription"]'
        );
        if (subscriptionRadio && !subscriptionRadio.checked) {
          subscriptionRadio.click();
        }
      }
    });

    // Initialize refill info
    initRefillInfo();

    // Initialize discount percentage display in variant picker
    initVariantPickerDiscount();
  }

  // Variant Picker Discount functionality
  function initVariantPickerDiscount() {
    var widget = document.querySelector("#juo-subscription-widget");
    if (!widget) {
      return;
    }

    function updateVariantPickerDiscount() {
      // Check if subscription mode is active
      var subscriptionMode = widget.querySelector(
        'input[name="mode"][value="subscription"]:checked'
      );

      // Get all discount spans (created by Liquid)
      var discountSpans = document.querySelectorAll(".variant-picker-discount");

      if (subscriptionMode) {
        // Show all discount spans when subscription mode is active
        discountSpans.forEach(function (span) {
          span.style.display = "inline";
        });
      } else {
        // Hide all discount spans when subscription mode is not active
        discountSpans.forEach(function (span) {
          span.style.display = "none";
        });
      }
    }

    // Initial update
    setTimeout(function () {
      updateVariantPickerDiscount();
    }, 200);

    // Listen for mode changes (subscription/otp)
    var modeInputs = widget.querySelectorAll('input[name="mode"]');
    modeInputs.forEach(function (input) {
      input.addEventListener("change", update);
      input.addEventListener("change", updateVariantPickerDiscount);
    });

    // Listen for selling plan changes
    widget.addEventListener("change", function (e) {
      if (e.target.name === "selling_plan") {
        updateVariantPickerDiscount();
      }
    });

    // Listen for variant changes
    var inputVariant =
      document.querySelector('input[name="id"]') ||
      document.querySelector('.product-form input[name="id"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="id"]');

    if (inputVariant) {
      inputVariant.addEventListener("change", updateVariantPickerDiscount);
    }

    // Listen for custom variant change events
    document.addEventListener("natulimOptionValueChanged", function () {
      setTimeout(updateVariantPickerDiscount, 100);
    });

    // Listen for variant change events from Shopify
    document.addEventListener("variant:change", function () {
      setTimeout(updateVariantPickerDiscount, 100);
    });
  }

  // Refill Info functionality
  function initRefillInfo() {
    var widget = document.querySelector("#juo-subscription-widget");
    if (!widget) {
      return;
    }

    // Try to get variantjson element
    if (!window.variantjson) {
      window.variantjson = document.querySelector("#product-variants-data");
    }

    var refillInfoElement = widget.querySelector(".juo-refill-info");
    if (!refillInfoElement) {
      return;
    }

    function updateRefillInfo() {
      // Always refresh window.variantjson in case it wasn't set or DOM changed
      if (!window.variantjson) {
        window.variantjson = document.querySelector("#product-variants-data");
      }

      // Try multiple selectors for variant input
      var inputVariant =
        document.querySelector('input[name="id"]') ||
        document.querySelector('.product-form input[name="id"]') ||
        document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (!inputVariant) {
        refillInfoElement.textContent = "";
        refillInfoElement.id = "juo-refill-info-unknown";
        return;
      }

      var variantId = inputVariant.value;

      if (!variantId) {
        refillInfoElement.textContent = "";
        refillInfoElement.id = "juo-refill-info-unknown";
        return;
      }

      var variantData = null;

      // window.variantjson is a DOM element (e.g., #product-variants-data)
      if (window.variantjson) {
        if (window.variantjson.textContent) {
          try {
            variantData = JSON.parse(window.variantjson.textContent);
          } catch (e) {
            refillInfoElement.textContent = "";
            refillInfoElement.id = "juo-refill-info-unknown";
            return;
          }
        } else {
          refillInfoElement.textContent = "";
          refillInfoElement.id = "juo-refill-info-unknown";
          return;
        }
      } else {
        refillInfoElement.textContent = "";
        refillInfoElement.id = "juo-refill-info-unknown";
        return;
      }

      if (!variantData) {
        refillInfoElement.textContent = "";
        refillInfoElement.id = "juo-refill-info-unknown";
        return;
      }

      var getcurrentvariant = null;
      if (Array.isArray(variantData)) {
        getcurrentvariant = variantData.find(function (data) {
          return data.id.toString() == variantId.toString();
        });
      } else if (variantData.variants && Array.isArray(variantData.variants)) {
        getcurrentvariant = variantData.variants.find(function (data) {
          return data.id.toString() == variantId.toString();
        });
      }

      if (!getcurrentvariant) {
        refillInfoElement.textContent = "";
        refillInfoElement.id = "juo-refill-info-unknown";
        return;
      }

      // Check different possible metafield structures
      var refillInfo = "";
      var refillPrice = "";

      if (getcurrentvariant.metafields) {
        // Try custom.refill_info
        if (
          getcurrentvariant.metafields.custom &&
          getcurrentvariant.metafields.custom.refill_info
        ) {
          refillInfo = getcurrentvariant.metafields.custom.refill_info;
        }
        // Try custom.refill_price
        if (
          getcurrentvariant.metafields.custom &&
          getcurrentvariant.metafields.custom.refill_price
        ) {
          refillPrice = getcurrentvariant.metafields.custom.refill_price;
        }
        // Try direct metafields
        if (!refillInfo && getcurrentvariant.metafields.refill_info) {
          refillInfo = getcurrentvariant.metafields.refill_info;
        }
        if (!refillPrice && getcurrentvariant.metafields.refill_price) {
          refillPrice = getcurrentvariant.metafields.refill_price;
        }
      }

      if (refillInfo || refillPrice) {
        refillInfoElement.innerHTML =
          '<span class="juo-refill-info__label" style="font-size: 14px;">' +
          refillInfo +
          '</span> <span class="juo-refill-info__amount" >' +
          refillPrice +
          "</span>";
        refillInfoElement.id = "juo-refill-info-" + getcurrentvariant.id;
      } else {
        refillInfoElement.textContent = "";
        refillInfoElement.id = "juo-refill-info-" + getcurrentvariant.id;
      }
    }

    // Wait a bit for DOM to be ready, then initial update
    setTimeout(function () {
      updateRefillInfo();
    }, 100);

    // Listen for variant changes
    var inputVariant =
      document.querySelector('input[name="id"]') ||
      document.querySelector('.product-form input[name="id"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="id"]');

    if (inputVariant) {
      inputVariant.addEventListener("change", updateRefillInfo);
    }

    // Also listen for custom variant change events
    document.addEventListener("natulimOptionValueChanged", updateRefillInfo);

    // Listen for variant change events from Shopify
    document.addEventListener("variant:change", updateRefillInfo);
  }

  function main() {
    if (window.Shopify != null) {
      function init() {
        var dataElement = document.getElementById(
          "juo-subscription-widget-data"
        );

        if (!dataElement || !dataElement.innerText) {
          return;
        }

        try {
          var data = JSON.parse(dataElement.innerText);
          var variants = data[0];
          var variantId = data[1];
          var moneyFormat = data[2];

          initWidget(variants, variantId, moneyFormat);
        } catch (error) {
          // Silent error handling
        }
      }

      if (
        document.readyState === "complete" ||
        document.readyState === "interactive"
      ) {
        init();
      } else {
        document.addEventListener("DOMContentLoaded", init);
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", main);
  } else {
    main();
  }
})();
